module.exports = __webpack_public_path__ + "22b9546f2ed34a8879970710272aebc6.svg";